import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  ChevronRight,
  CreditCard,
  FileText,
  MapPin,
  ReceiptText,
  Settings,
} from "lucide-react";
import "./MyOrdersPage.css";

const SubsOrderDetail = () => {
  const navigate = useNavigate();

  return (
    <section className="orders-detail-page">
      <div className="orders-detail-shell">
        <section className="orders-mobile-page orders-mobile-detail-page">
          <header className="orders-mobile-detail-header">
            <button
              type="button"
              className="orders-mobile-back"
              onClick={() => navigate("/MyOrders")}
              aria-label="Back to orders"
            >
              <ArrowLeft size={20} strokeWidth={2.2} />
            </button>
            <div>
              <span>SUBSCRIPTION</span>
              <h1>Order Details</h1>
            </div>
          </header>

          <div className="orders-mobile-detail-stack">
            <section className="orders-mobile-info-card">
              <div className="orders-mobile-info-row">
                <span>Subscription charged on</span>
                <strong>12th Jan 2024, 10:30 AM</strong>
              </div>
              <div className="orders-mobile-info-row">
                <span>Order Number</span>
                <strong className="order-number-value">
                  D01-2129909-9515822
                </strong>
              </div>
            </section>

            <section className="orders-mobile-product-detail-card">
              <div className="orders-mobile-detail-product">
                <div className="orders-mobile-detail-product-image">
                  <img
                    src="./assets/img/salarlogo.png"
                    alt="Salar Membership"
                  />
                </div>
                <div>
                  <h3>Salar Membership</h3>
                  <p>
                    Sold by: <strong>Sworld Solutions pvt ltd</strong>
                  </p>
                  <b>₹1499</b>
                </div>
              </div>

              <div className="orders-mobile-action-grid">
                <button type="button" className="primary">
                  <Settings size={17} strokeWidth={2} />
                  <span>Manage your subscription</span>
                </button>
              </div>
            </section>

            <section className="orders-mobile-menu-section">
              <div className="orders-mobile-section-heading">
                <span>
                  <FileText size={18} strokeWidth={2} />
                </span>
                <h2>Order Info</h2>
              </div>
              <div className="orders-mobile-menu-card">
                <button type="button">
                  <span className="orders-mobile-menu-icon">
                    <FileText size={18} strokeWidth={2} />
                  </span>
                  <span>Download Invoice</span>
                  <ChevronRight size={19} strokeWidth={2} />
                </button>
              </div>
            </section>

            <section className="orders-mobile-simple-section">
              <div className="orders-mobile-section-heading">
                <span>
                  <CreditCard size={18} strokeWidth={2} />
                </span>
                <h2>Payment Method</h2>
              </div>
              <div className="orders-mobile-simple-card">Phone Pe UPI</div>
            </section>

            <section className="orders-mobile-simple-section">
              <div className="orders-mobile-section-heading">
                <span>
                  <MapPin size={18} strokeWidth={2} />
                </span>
                <h2>Recipient</h2>
              </div>
              <address className="orders-mobile-address-card">
                <strong>Siddharth</strong>
              </address>
            </section>

            <section className="orders-mobile-simple-section">
              <div className="orders-mobile-section-heading">
                <span>
                  <ReceiptText size={18} strokeWidth={2} />
                </span>
                <h2>Order Summary</h2>
              </div>
              <div className="orders-mobile-summary-card">
                <div>
                  <span>Item(s) Subtotal</span>
                  <strong>₹1499</strong>
                </div>
                <div className="grand-total">
                  <span>Total for this Order</span>
                  <strong>₹1499</strong>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>
    </section>
  );
};

export default SubsOrderDetail;
